
import React from 'react';
import { ComponentNode } from '../types/template';
import { convertStylesToInline, getCustomThemeItemsLayoutStyle } from '../utils/styleUtils';
import ComponentRenderer from './ComponentRenderer';
import MerchantSectionSlider from './MerchantSectionSlider';
import { getNestedValue } from '../utils/dataBinding';
import { normalizeTemplateItem } from '../utils/normalizeTemplateItem';

interface CardComponentProps {
    component: ComponentNode;
    data?: any;
    context?: any;
}

const CardComponent: React.FC<CardComponentProps> = ({ component, data, context }) => {
    const { styles, components, repeated, dataSourceKey, gridCols, gridGap, itemsLayout, customClassName } = component;
    const inlineStyles = convertStylesToInline(styles);
    const isOfferBannerCard = components?.some(
        (child) => child.type === 'LINK' && child.components?.some((image) => image.placeholder === 'offer.banner_image'),
    );
    const cardStyles = isOfferBannerCard
        ? { ...inlineStyles, width: '100%', maxWidth: styles?.maxWidth || '320px', margin: styles?.margin || '0 auto 16px' }
        : inlineStyles;

    const repeatedSource = (() => {
        if (Array.isArray(data)) {
            return data;
        }

        if (repeated && dataSourceKey) {
            const nestedSource = getNestedValue(data, dataSourceKey);
            if (Array.isArray(nestedSource)) {
                return nestedSource;
            }
        }

        return null;
    })();

    if (repeatedSource) {
        const items = component.totalCards ? repeatedSource.slice(0, component.totalCards) : repeatedSource;

        if (component.sliderEnabled) {
            const sliderCardComponent = { ...component, repeated: false };

            return (
                <MerchantSectionSlider
                    items={items}
                    cardComponent={sliderCardComponent}
                    context={context}
                    totalCards={component.totalCards}
                    autoPlay={component.autoPlay}
                    slideInterval={component.slideInterval}
                />
            );
        }

        const gridStyle = getCustomThemeItemsLayoutStyle(itemsLayout, gridCols, gridGap);

        return (
            <div style={gridStyle} className={itemsLayout === 'flex-wrap' || itemsLayout === 'flex-nowrap' ? undefined : 'cb-responsive-grid'}>
                {items.map((item: any, index: number) => (
                    <div key={index} style={cardStyles}>
                        {components?.map((child) => (
                            <ComponentRenderer
                                key={child.id}
                                component={child}
                                data={normalizeTemplateItem(item)}
                                context={context}
                            />
                        ))}
                    </div>
                ))}
            </div>
        );
    }
    return (
        <div style={{ display: 'grid', ...cardStyles }} className={customClassName}>
            {components?.map((child) => (
                <ComponentRenderer key={child.id} component={child} data={data} context={context} />
            ))}
        </div>
    );
};

export default CardComponent;
